import React, { useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { t } from '@lingui/macro';
import { CaretLeftIcon } from '@patternfly/react-icons';
import { Button } from '@patternfly/react-core';
import { CardBody, CardActionsRow } from '../../../../components/Card';
import ContentLoading from '../../../../components/ContentLoading';
import ContentError from '../../../../components/ContentError';
import { DetailList } from '../../../../components/DetailList';
import RoutedTabs from '../../../../components/RoutedTabs';
import useRequest from '../../../../util/useRequest';
import { useConfig } from '../../../../contexts/Config';
import { useSettings } from '../../../../contexts/Settings';
import { SettingsAPI } from '../../../../api';
import { SettingDetail } from '../../shared';

function ActivityStreamDetail() {
  const { me } = useConfig();
  const { GET: options } = useSettings();

  const { isLoading, error, request, result: activityStream } = useRequest(
    useCallback(async () => {
      const {
        data: {
          ACTIVITY_STREAM_ENABLED,
          ACTIVITY_STREAM_ENABLED_FOR_INVENTORY_SYNC,
        },
      } = await SettingsAPI.readCategory('system');
      return {
        ACTIVITY_STREAM_ENABLED,
        ACTIVITY_STREAM_ENABLED_FOR_INVENTORY_SYNC,
      };
    }, []),
    null
  );

  useEffect(() => {
    request();
  }, [request]);

  const tabsArray = [
    {
      name: (
        <>
          <CaretLeftIcon />
          {t`Back to Settings`}
        </>
      ),
      link: `/settings`,
      id: 99,
    },
    {
      name: t`Details`,
      link: `/settings/activity_stream/details`,
      id: 0,
    },
  ];

  return (
    <>
      <RoutedTabs tabsArray={tabsArray} />
      <CardBody>
        {isLoading && <ContentLoading />}
        {!isLoading && error && <ContentError error={error} />}
        {!isLoading && activityStream && (
          <DetailList>
            {Object.keys(activityStream).map(key => {
              const record = options?.[key];
              return (
                <SettingDetail
                  key={key}
                  id={key}
                  helpText={record?.help_text}
                  label={record?.label}
                  type={record?.type}
                  unit={record?.unit}
                  value={activityStream?.[key]}
                />
              );
            })}
          </DetailList>
        )}
        {me?.is_superuser && (
          <CardActionsRow>
            <Button
              ouiaId="activity-stream-detail-edit-button"
              aria-label={t`Edit`}
              component={Link}
              to="/settings/activity_stream/edit"
            >
              {t`Edit`}
            </Button>
          </CardActionsRow>
        )}
      </CardBody>
    </>
  );
}

export default ActivityStreamDetail;
